'use client'
import { useRouter } from 'next/navigation'
import { useState, useCallback } from 'react'
import { Loader2 } from 'lucide-react'

interface LoadingButtonProps {
  href: string
  className: string
  children: React.ReactNode
  'aria-label'?: string
}

export function LoadingButton({ href, className, children, ...props }: LoadingButtonProps) {
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()
  
  const handleClick = useCallback(async (e: React.MouseEvent) => {
    e.preventDefault()
    
    if (isLoading) return
    
    setIsLoading(true)
    
    try {
      await router.push(href)
    } catch (error) {
      setIsLoading(false)
    }
  }, [href, isLoading, router])
  
  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className={`${className} ${isLoading ? 'cursor-not-allowed opacity-75' : ''}`}
      aria-disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <Loader2 className="w-4 h-4 sm:w-5 sm:h-5 mr-2 animate-spin flex-shrink-0" />
          <span>Loading...</span>
        </>
      ) : (
        children
      )}
    </button>
  )
} 